import React, {Component} from 'react';
import Particles from 'particlesjs';

import './CummerbundParticles.css';

export default class CummerbundParticles extends Component {
  componentDidMount() {
    Particles.init({
      color: '#fdfdfd',
      speed: 0.1,
      maxParticles: 40,
      connectParticles: true,
      responsive: [
        {
          breakpoint: 1350,
          options: {
            maxParticles: 24
          }
        },
        {
          breakpoint: 992,
          options: {
            maxParticles: 16
          }
        },
        {
          breakpoint: 767,
          options: {
            maxParticles: 12
          }
        },
        {
          breakpoint: 400,
          options: {
            maxParticles: 10
          }
        }
      ],
      selector: '#cummerbund'
    });
  }

  render() {
    return (
      <div className='cummerbund-background'>
        <canvas id='cummerbund'>

        </canvas>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/CummerbundParticles.js